export class Sheet {
  grade: number | null = 0
  name: string = ""
  curriculum_id: number | null = 0
  page_count: number | null = 0
  correct_image_size: number[]
  sheet_process: any
}